import React, { useState } from 'react';
import { FaArrowLeft, FaFileInvoice, FaSave, FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import CustomerModal from '../components/CustomerModal';
import { usePurchaseInvoiceData } from '../components/purchase/edit/usePurchaseInvoiceData';
import InvoiceFormSection from '../components/purchase/edit/InvoiceFormSection';
import SupplierSection from '../components/purchase/edit/SupplierSection';
import ProductsTable from '../components/purchase/edit/ProductsTable';

const cardStyle = {
  backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)',
  borderRadius: '6px', marginBottom: '0.75rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
};
const cardHeaderStyle = {
  padding: '0.5rem 0.75rem', borderBottom: '1px solid var(--border)',
  backgroundColor: 'var(--bg)', fontSize: '12px', fontWeight: '600',
  color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '0.5rem'
};
const inputStyle = {
  width: '100%', padding: '6px 10px',
  border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px',
  backgroundColor: 'var(--card-bg)', color: 'var(--text)'
};
const labelStyle = {
  display: 'block', marginBottom: '0.25rem', fontSize: '11px', fontWeight: '500', color: 'var(--text-secondary)'
};
const btnStyle = {
  padding: '4px 10px', fontSize: '11px', fontWeight: '500',
  cursor: 'pointer',
  display: 'flex', alignItems: 'center', gap: '0.35rem'
};

const PurchaseInvoiceEditPage = () => {
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);

  const data = usePurchaseInvoiceData();

  const sharedStyles = { cardStyle, cardHeaderStyle, inputStyle, labelStyle, btnStyle };

  if (data.loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Ladowanie...</div>
      </div>
    );
  }

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{
          ...cardStyle,
          padding: '0.75rem 1rem',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', color: 'var(--text)' , border: 'none'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <FaFileInvoice style={{ fontSize: '1.25rem' }} />
            <div>
              <h1 style={{ margin: 0, fontSize: '1rem', fontWeight: '700' }}>
                {data.isNewMode ? 'Nowa faktura zakupowa' : `Edycja: ${data.formData.numer_faktury || `FZ-${data.id}`}`}
              </h1>
              <p style={{ margin: 0, fontSize: '11px', opacity: 0.9 }}>
                {data.isNewMode ? 'Dodaj nowa fakture recznie' : 'Edycja danych faktury'}
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button onClick={data.handleSave} disabled={data.saving} style={{ ...btnStyle, backgroundColor: 'var(--card-bg)', color: 'var(--success)' }}>
              <FaSave /> {data.saving ? 'Zapisuje...' : 'Zapisz'}
            </button>
            {/* var(--text): bialy tekst byl niewidoczny na jasnym tle bg-secondary */}
            <button onClick={() => data.navigate('/purchase-invoices/list')} style={{ ...btnStyle, backgroundColor: 'var(--bg-secondary)', color: 'var(--text)' }}>
              <FaTimes /> Anuluj
            </button>
          </div>
        </div>

        {data.error && (
          <div style={{
            padding: '0.5rem 0.75rem', backgroundColor: 'var(--danger-light)',
            border: '1px solid var(--danger-light)', borderRadius: '4px', color: 'var(--danger)',
            fontSize: '12px', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem'
          }}>
            <FaExclamationTriangle /> {data.error}
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
          <div>
            <InvoiceFormSection
              formData={data.formData}
              handleInputChange={data.handleInputChange}
              {...sharedStyles}
            />
            <div style={cardStyle}>
              <div style={cardHeaderStyle}>Uwagi</div>
              <div style={{ padding: '0.75rem' }}>
                <textarea
                  value={data.formData.uwagi}
                  onChange={(e) => data.handleInputChange('uwagi', e.target.value)}
                  style={{ ...inputStyle, minHeight: '60px', resize: 'vertical' }}
                  placeholder="Dodatkowe uwagi..."
                />
              </div>
            </div>
          </div>

          <SupplierSection
            formData={data.formData}
            handleInputChange={data.handleInputChange}
            customerSearch={data.customerSearch}
            setCustomerSearch={data.setCustomerSearch}
            customerResults={data.customerResults}
            showCustomerResults={data.showCustomerResults}
            setShowCustomerResults={data.setShowCustomerResults}
            selectedCustomer={data.selectedCustomer}
            clearCustomer={data.clearCustomer}
            handleSelectCustomer={data.handleSelectCustomer}
            onAddNewCustomer={() => setShowAddCustomerModal(true)}
            {...sharedStyles}
          />
        </div>

        <ProductsTable
          products={data.products}
          units={data.units}
          productSearchIndex={data.productSearchIndex}
          setProductSearchIndex={data.setProductSearchIndex}
          productSearchQuery={data.productSearchQuery}
          setProductSearchQuery={data.setProductSearchQuery}
          productSearchResults={data.productSearchResults}
          showProductResults={data.showProductResults}
          searchingProducts={data.searchingProducts}
          productSearchRef={data.productSearchRef}
          saveNewProducts={data.saveNewProducts}
          setSaveNewProducts={data.setSaveNewProducts}
          handleSelectProduct={data.handleSelectProduct}
          addProduct={data.addProduct}
          updateProduct={data.updateProduct}
          removeProduct={data.removeProduct}
          calculateTotal={data.calculateTotal}
          {...sharedStyles}
        />
      </div>

      <CustomerModal
        isOpen={showAddCustomerModal}
        onClose={() => setShowAddCustomerModal(false)}
        onSuccess={(newCustomer) => {
          data.handleSelectCustomer(newCustomer);
          setShowAddCustomerModal(false);
        }}
        initialData={{ typ_klienta: 'firma' }}
      />
    </div>
  );
};

export default PurchaseInvoiceEditPage;
